import { Weight } from "@faire/web--source/slate/Font/utils";
import { getSpacing } from "@faire/web--source/slate/spacing";
import { Typography } from "@faire/web--source/slate/Typography";
import { StrictLocalMsg } from "@faire/web--source/ui/lib/localization";
import React from "react";
import styled from "styled-components";

export const CollectedCSAT = () => {
  return (
    <StyledTypography>
      <StrictLocalMsg
        defaultMessage="Thanks for your feedback!"
        description={{
          text: "Message shown to users after they submit their feedback on the usefulness of our help center suggested solution",
        }}
      />
    </StyledTypography>
  );
};

const StyledTypography = styled(Typography)`
  &&& {
    margin-top: ${getSpacing("4x")};
    font-weight: ${Weight.medium};
  }
`;
